/* eslint-disable @typescript-eslint/naming-convention */
import type { ContentArea, GlobalFieldReference } from '@ps/web-martech-cms-types';
import type { MatchDataBlock } from '@ps/web-martech-cms-types/ContentArea';
import React from 'react';

import { CMSMatch, CMSPageSection, CMSReference } from '@swf/cms';

import styles from './CMSContentArea.scss';

const CMSContentArea: React.FC<ContentArea> = ({ item_alignment, heading, body }) =>
  heading.title || body.length ? (
    <CMSPageSection heading={heading} gridClassName={styles[item_alignment || '']}>
      {body.map((item, index) => {
        const [[type, value]] = Object.entries(item);
        if (type === 'cta') {
          value.className = styles.cta;
        } else if (['widget', 'feed'].includes(type)) {
          return <CMSReference key={index} {...value.reference[0]} />;
        } else if (type === 'match_data') {
          return <CMSMatch key={index} {...(item as MatchDataBlock)} />;
        }
        return <CMSReference key={index} {...(item as GlobalFieldReference)} />;
      })}
    </CMSPageSection>
  ) : null;

export default CMSContentArea;
